/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import { IVinhusetFullscreenContentBlockViewProps } from './vinhuset-fullscreen-content-block';

export default (props: IVinhusetFullscreenContentBlockViewProps) => {
    const {
        title,
        text,
        links,
        backgroundImage,
        contentBlockContainer,
        detailsContainer,
        backgroundImageContainer
    } = props;

    return (
        <Module {...contentBlockContainer}>
            <Node {...backgroundImageContainer}>
                {backgroundImage}
            </Node>
            <Node {...detailsContainer}>
                {title}
                {text}
            </Node>
            {links}
        </Module>
    );
};
